export default __webpack_public_path__ + "static/media/europa.662a0ef8.png";